import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';

import Modal from 'app/components/common/modal';
import GrantSysDuck from 'app/ducks/company-admin/grant-system';
import StandardSelect from 'app/components/common/standard-select';
import StandardInput from 'app/components/common/standard-input';
import RteEditor from 'app/components/common/rich-text/editor';
import prompts from 'app/prompts';

const typeOpts = [
  {label: 'Award Letter', value: 'approved'},
  {label: 'Declined Notification', value: 'declined'},
];

class CadminModalEmailForm extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      type: null,
      subject: null,
      body: null,
      savePending: false,
      hasLoaded: false,
      deletePending: false,
    };

    this.onChangeType = this.onChangeType.bind(this);
    this.onChangeSubject = this.onChangeSubject.bind(this);
    this.onChangeBody = this.onChangeBody.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
  }

  get saveAttrs() {
    return {
      type: this.state.type,
      subject: (this.state.subject || '').trim(),
      body: (this.state.body || '').trim(),
    };
  }

  componentDidMount() {
    const {email} = this.props;
    if (email) {
      this.setState({
        subject: email.subject,
        body: email.body,
        type: email.type,
        hasLoaded: true,
      });
    } else {
      this.setState({hasLoaded: true});
    }
  }

  get isNew() {
    return !this.props.email?.id;
  }
  get hasAllAttrs() {
    const attrs = this.saveAttrs;
    if (!attrs.subject) return false;
    if (!attrs.type) return false;
    if (!attrs.body) return false;
    return true;
  }
  get btnDisabled() {
    if (this.state.savePending || this.state.deletePending) return true;
    if (!this.hasAllAttrs) return true;
    return false;
  }
  get btnLabel() {
    return this.state.savePending
      ? (this.isNew ? 'Creating...' : 'Updating...')
      : (this.isNew ? 'Create Email Template' : 'Update Email Template');
  }

  onChangeType(type) {
    this.setState({type});
  }
  onChangeSubject(event) {
    const subject =  event.target.value;
    this.setState({subject});
  }
  onChangeBody(md) {
    this.setState({body: md});
  }

  async onClickDelete() {
    const didConfirm = await prompts.confirm({msg: 'This can not be undone.', danger: 'Delete Email Template'});
    if (didConfirm) {
      this.setState({deletePending: true});
      await this.props.delete();
      this.setState({deletePending: false});
      this.props.onClose();
    }
  }

  async onClickSubmit() {
    this.setState({savePending: true});
    const promise = this.isNew
      ? this.props.create(this.saveAttrs)
      : this.props.update(this.saveAttrs);
    await promise;
    this.setState({savePending: false});
    this.props.onClose();
  }

  render() {
    return (
      <Modal onClose={this.props.onClose} className="bform">
        <h1 className="bform-h1">{this.isNew ? 'New Email Template' : 'Edit Email Template'}</h1>

        <label className="bform-h3">Type</label>
        <StandardSelect options={typeOpts} value={this.state.type} onSelect={this.onChangeType} allowClear />

        <label className="bform-h3">Subject</label>
        <StandardInput name="subject" label="Subject" value={this.state.subject || ''} onChange={this.onChangeSubject} />
        
        <label className="bform-h3">Body</label>
        {!!this.state.hasLoaded && (
          <RteEditor initialMd={this.state.body} onChange={this.onChangeBody} />
        )}

        <div className="bform-actions">
          {!this.isNew && (
            <button onClick={this.onClickDelete} disabled={this.state.deletePending} className="btn danger secondary">{this.state.deletePending ? 'Deleting...' : 'Delete'}</button>
          )}
          <div className="bform-actions-right">
            <button className="btn blue" disabled={this.btnDisabled} onClick={this.onClickSubmit}>{this.btnLabel}</button>
          </div>
        </div>
      </Modal>
    );
  }

}

const stateToProps = (state) => ({});

const dispatchToProps = (dispatch, ownProps) => ({
  update: (attrs) => dispatch(GrantSysDuck.Ax.emailsUpdate(ownProps.company.id, ownProps.email.id, attrs)),
  create: (attrs) => dispatch(GrantSysDuck.Ax.emailsCreate(ownProps.company.id, attrs)),
  delete: () => dispatch(GrantSysDuck.Ax.emailsDelete(ownProps.company.id, ownProps.email.id)),
});

export default connect(stateToProps, dispatchToProps)(CadminModalEmailForm);
